export default __webpack_public_path__ + "static/media/Snd_ClowerY.7330f083.mp3";